import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin-tabs"
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = {
    defaultTab: { type: Number, default: 1 }
  }

  connect() {
    this.currentTab = this.defaultTabValue
    this.updateTabs()
  }

  selectTab(event) {
    event.preventDefault()

    const tab = event.currentTarget
    const index = parseInt(tab.dataset.adminTabsIndexParam)

    if (index === this.currentTab) return

    this.currentTab = index
    this.updateTabs()
  }

  updateTabs() {
    this.tabTargets.forEach((tab) => {
      const index = parseInt(tab.dataset.adminTabsIndexParam)
      const activeClasses = tab.dataset.adminTabsActiveClassesParam.split(" ").filter(Boolean)
      const inactiveClasses = tab.dataset.adminTabsInactiveClassesParam.split(" ").filter(Boolean)

      if (index === this.currentTab) {
        // Activate tab
        tab.setAttribute("aria-selected", "true")
        tab.classList.remove(...inactiveClasses)
        tab.classList.add(...activeClasses)
      } else {
        // Deactivate tab
        tab.setAttribute("aria-selected", "false")
        tab.classList.remove(...activeClasses)
        tab.classList.add(...inactiveClasses)
      }
    })

    this.panelTargets.forEach((panel) => {
      const index = parseInt(panel.dataset.adminTabsIndexParam)
      panel.hidden = index !== this.currentTab
    })
  }

  // Keyboard navigation support
  keydown(event) {
    const currentTabElement = this.tabTargets.find(
      (tab) => parseInt(tab.dataset.adminTabsIndexParam) === this.currentTab
    )

    if (!currentTabElement) return

    let newIndex = this.currentTab

    switch (event.key) {
      case "ArrowLeft":
        event.preventDefault()
        newIndex = this.currentTab > 1 ? this.currentTab - 1 : this.tabTargets.length
        break
      case "ArrowRight":
        event.preventDefault()
        newIndex = this.currentTab < this.tabTargets.length ? this.currentTab + 1 : 1
        break
      case "Home":
        event.preventDefault()
        newIndex = 1
        break
      case "End":
        event.preventDefault()
        newIndex = this.tabTargets.length
        break
      default:
        return
    }

    this.currentTab = newIndex
    this.updateTabs()

    // Focus the new tab
    const newTabElement = this.tabTargets.find(
      (tab) => parseInt(tab.dataset.adminTabsIndexParam) === newIndex
    )
    if (newTabElement) {
      newTabElement.focus()
    }
  }
}
